/* Data Hub · Quest 1 in plain words (Jan, Sept 29 2026: "how many emails did I get and how many phone numbers did I get").
   Loaded only by sections/ff-data-hub.liquid, which has to stay 60 KB under Shopify's 256 KB cap (harness/check-data-hub-section.cjs),
   so this lives beside it like the other panels' scripts. The section hands over the helpers it already has and calls in when a quest
   panel has numbers to draw. This file draws the sentence and the three tiles, the hour and day chart (bars or lines) and the phones vs
   computers block. Styles: assets/ff-data-hub-quest.css. Checks: harness/data-hub-full-browser.cjs. */
(function(){
  "use strict";
  window.ffQuestView=function(ctx){
    var el=ctx.el,n=ctx.n,delta=ctx.delta,rngTag=ctx.rngTag,baseOpts=ctx.baseOpts,getMode=ctx.getMode,killChart=ctx.killChart,
        setEmpty=ctx.setEmpty,charts=ctx.charts,seriesCache=ctx.seriesCache,trimLead=ctx.trimLead;
    /* Times and days in plain words, for the charts that draw one bar per hour or per day: "2pm", "Sep 28". A tick
       that starts a new day carries the weekday under it, so a 3 day window does not read as one repeating afternoon. */
    var WEEKDAY=["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],MONTH=["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
    function clock(h){return (h%12||12)+(h<12?"am":"pm")}
    function hourLabel(iso){return clock(new Date(iso).getHours())}
    function hourTitle(iso){var d=new Date(iso),h=d.getHours();return WEEKDAY[d.getDay()]+" "+clock(h)+" to "+clock((h+1)%24)}
    function hourTicks(rows){
      return rows.map(function(x,i){
        var d=new Date(x.hr),l=clock(d.getHours());
        return (d.getHours()===0||(i===0&&rows.length>24))?[l,WEEKDAY[d.getDay()]]:l;
      });
    }
    function dayOf(day){return new Date(String(day).slice(0,10)+"T12:00:00")}
    function dayLabel(day){var d=dayOf(day);return isNaN(d.getTime())?String(day).slice(5):MONTH[d.getMonth()]+" "+d.getDate()}
    function dayTitle(day){var d=dayOf(day);return isNaN(d.getTime())?String(day):WEEKDAY[d.getDay()]+", "+MONTH[d.getMonth()]+" "+d.getDate()}
    /* QUEST 1: PLAYERS, EMAILS AND PHONE NUMBERS, IN PLAIN WORDS (Jan, Sept 29 2026: "claimed doesn't mean anything").
       R451 (Aug 19 2026) split the old "Claimed" bar because the waitlist runs on phone numbers. The split stays; the
       names were the trouble, so the chart now says what it counts: how many started, how many gave an email, and how
       many of those also left a phone number. BOTH email numbers come from quiz_leads on purpose: quest_sessions only
       recorded reliably from July 2026, and a session count beside a lead count made the phone part tower over the
       emails on a long window (May 3 2026 read 0 finished sessions against 45 leads and 21 numbers). One source means
       the phone part can never outgrow the email total. Bars stack "email and phone" under "just an email", so the
       whole coloured column is everyone who gave an email in that hour or day, and the counts are written on the bars
       so nobody has to hover. Lines never stack (a stacked line reads bigger than it is): started, emails, phones. */
    function renderSplit(id,labels,starts,phones,emailOnly,startLabel,startColor,emptyMsg,titles){
      seriesCache[id]={split:true,labels:labels,a:starts,b:phones,c:emailOnly,aLabel:startLabel,aColor:startColor,empty:emptyMsg,titles:titles};
      var total=0,i;
      for(i=0;i<starts.length;i++)total+=(starts[i]||0);
      for(i=0;i<phones.length;i++)total+=(phones[i]||0);
      for(i=0;i<emailOnly.length;i++)total+=(emailOnly[i]||0);
      /* setEmpty appends its sentence to the END of the box, so a caption or key left showing would sit above a
         message saying there is nothing to explain. */
      var cap=el(id+"-note"),key=el(id+"-key");
      if(!labels.length||total===0){setEmpty(id,emptyMsg);if(cap)cap.style.display="none";if(key)key.style.display="none";return}
      setEmpty(id,null);
      if(cap)cap.style.display="";
      if(key)key.style.display="";
      killChart(id);
      var cv=el(id);if(!cv)return;
      cv.parentNode.style.height="268px";
      var bar=getMode(id)==="bar",BLUE="#8ad0e8",GREEN="#7fd6a2",GOLD=startColor||"#c9a961";
      var emails=labels.map(function(x,j){return (phones[j]||0)+(emailOnly[j]||0)});
      var sw=function(c){return '<i style="background:'+c+'"></i>'},lw=function(c){return '<i class="ln" style="background:'+c+'"></i>'};
      if(key)key.innerHTML=bar
        ?'<span class="k">'+sw(GOLD)+'Started the quest</span><span class="k">'+sw(BLUE)+'Email and phone number</span><span class="k">'+sw(GREEN)+'Email only</span>'
        :'<span class="k">'+lw(GOLD)+'Started the quest</span><span class="k">'+lw(GREEN)+'Gave an email</span><span class="k">'+lw(BLUE)+'Also left a phone number</span>';
      if(cap)cap.textContent=bar?"Blue and green together are everyone who gave an email. The blue part also left a phone number."
        :"The green line is everyone who gave an email. The blue line is the ones who also left a phone number.";
      cv.setAttribute("role","img");
      cv.setAttribute("aria-label","Chart of how many people started the quest, gave an email, and left a phone number.");
      var o=baseOpts();
      o.plugins.legend={display:false};
      o.layout={padding:{top:bar?20:8,right:4}};
      o.interaction={mode:"index",intersect:false};
      o.scales.x.grid={display:false};
      o.scales.x.ticks={color:"#a39bb4",font:{size:11.5},maxRotation:0,autoSkip:true,maxTicksLimit:12};
      o.scales.y.ticks={color:"#a39bb4",font:{size:11.5},precision:0,maxTicksLimit:6};
      o.scales.y.grace="10%";
      if(bar){o.scales.x.stacked=true;o.scales.y.stacked=true}
      /* One tooltip per hour or day, in sentences: hovering a column answers "how many started, how many gave an
         email, how many of those left a number" in a single read. */
      o.plugins.tooltip={backgroundColor:"#1b1b28",borderColor:"#3a3a55",borderWidth:1,titleColor:"#efe8da",bodyColor:"#d8d2e4",padding:10,
        filter:function(item){return bar?item.datasetIndex<2:true},
        callbacks:{
          title:function(items){var j=items&&items[0]?items[0].dataIndex:0;return (titles&&titles[j])||String(labels[j]||"").replace(/,/g," ")},
          label:function(ctx){
            var j=ctx.dataIndex,p=phones[j]||0,e=emails[j];
            if(ctx.datasetIndex===0)return "Started the quest: "+n(starts[j]||0);
            if(bar||ctx.datasetIndex===1)return "Gave an email: "+n(e)+(e&&p?" ("+n(p)+" also left a phone number)":"");
            return "Also left a phone number: "+n(p);
          }
        }};
      var sets;
      if(bar){
        /* only the top coloured piece of a column gets round corners */
        var round=function(k){return function(ctx){var j=ctx.dataIndex,t=(emailOnly[j]>0)?2:((phones[j]>0)?1:-1);return (k===0||ctx.datasetIndex===t)?{topLeft:5,topRight:5}:0}};
        sets=[
          {label:"Started the quest",data:starts,stack:"starts",backgroundColor:GOLD,borderRadius:round(0),borderSkipped:false,categoryPercentage:.82,barPercentage:.92},
          {label:"Email and phone number",data:phones,stack:"emails",backgroundColor:BLUE,borderRadius:round(1),borderSkipped:false,categoryPercentage:.82,barPercentage:.92},
          {label:"Email only",data:emailOnly,stack:"emails",backgroundColor:GREEN,borderRadius:round(2),borderSkipped:false,categoryPercentage:.82,barPercentage:.92}
        ];
      }else{
        var dot=function(c){return {borderColor:c,backgroundColor:c,pointBackgroundColor:c,pointBorderColor:"#0e0e15",pointBorderWidth:2,pointRadius:labels.length>40?0:4,pointHoverRadius:6,borderWidth:2.5,tension:.3}};
        sets=[
          Object.assign({label:"Started the quest",data:starts},dot(GOLD)),
          Object.assign({label:"Gave an email",data:emails},dot(GREEN)),
          Object.assign({label:"Also left a phone number",data:phones.map(function(v){return v||0})},dot(BLUE))
        ];
      }
      /* The counts, written on the bars: how many started above the gold column, how many gave an email above the
         coloured one, and the blue and green parts inside it when the column is tall enough to hold a number. */
      var values={id:"fhValues",afterDatasetsDraw:function(chart){
        var c=chart.ctx,m=[0,1,2].map(function(k){return chart.getDatasetMeta(k)}),j,bw=(m[0].data[0]&&m[0].data[0].width)||0;
        /* Thirty daily columns are too narrow to carry numbers without crowding: they keep their tooltip. */
        if(bw<12)return;
        c.save();c.textAlign="center";c.font="650 12px "+((window.Chart&&Chart.defaults&&Chart.defaults.font&&Chart.defaults.font.family)||"system-ui, sans-serif");
        for(j=0;j<labels.length;j++){
          var s=starts[j]||0,p=phones[j]||0,eo=emailOnly[j]||0,e=p+eo,bs=m[0].data[j],b1=m[1].data[j],b2=m[2].data[j],t=eo>0?b2:b1;
          c.textBaseline="bottom";
          if(s>0&&bs){c.fillStyle="#e7cf96";c.fillText(String(s),bs.x,bs.y-4)}
          if(e>0&&t){c.fillStyle="#bfead0";c.fillText(String(e),t.x,t.y-4)}
          if(p>0&&eo>0&&bw>=16){
            c.textBaseline="middle";
            if(b1&&Math.abs(b1.base-b1.y)>=18){c.fillStyle="#0d2a35";c.fillText(String(p),b1.x,(b1.y+b1.base)/2)}
            if(b2&&Math.abs(b2.base-b2.y)>=18){c.fillStyle="#0f2d1d";c.fillText(String(eo),b2.x,(b2.y+b2.base)/2)}
          }
        }
        c.restore();
      }};
      charts[id]=new Chart(cv,{type:bar?"bar":"line",data:{labels:labels,datasets:sets},options:o,plugins:bar?[values]:[]});
    }

    /* The Quest 1 chart, one bar or point per hour or per day. Rows come from quest1_version_report, quest1_daily or hub_hourly. */
    function questSeries(rows,color,hourMode){
      var empty="Nothing recorded in this window yet.",id="q1Line",r=rows||[],split=function(x){return Math.max(0,(x.leads||0)-(x.phones||0))};
      if(hourMode){
        /* hub_hourly's leads and phones are not split by quest, which is honest today because Quest 1 is the only quest writing
           lead rows. The day Quest 2 starts writing them, that filter has to move into hub_hourly before this can stay. */
        renderSplit(id,hourTicks(r),r.map(function(x){return x.q1_starts||0}),r.map(function(x){return x.phones||0}),r.map(split),
          "Started the quest",color,empty,r.map(function(x){return hourTitle(x.hr)}));
        return;
      }
      r=r.slice().reverse();
      /* R451b. The leading trim runs on EVERY window, not just All time (Jan, Aug 19 2026: "it should only start at the earliest
         active date so 90 days dont look like a flat line"). Starts decides the left edge, so a day the quest never recorded a
         player in cannot hold it. Interior quiet days stay, because those are real. */
      r=trimLead(r,["starts","finished"]);
      /* quest1_daily already returned leads and phones, the hub simply never drew them, so this needs no SQL. leads is every email
         (the gate always takes one), phones is the subset who also left a number, including the ones the R283 late attach fills in
         after the submit. */
      renderSplit(id,r.map(function(x){return dayLabel(x.day)}),r.map(function(x){return x.starts||0}),r.map(function(x){return x.phones||0}),r.map(split),
        "Started the quest",color,empty,r.map(function(x){return dayTitle(x.day)}));
    }
    /* Phones vs computers. R232 computed the mobile share and each side's finish rate, and the hub only ever drew a bar
       chart of the finish rates: "18%" and "100%" under a caption about a different number ("94.4% of starts came from
       a phone"), which read as 18% of what? (Jan, Sept 29 2026.) This says it in words, with a bar for who plays on
       what. Cold paid social is mostly phones, so this is where you see whether the quest loses people on a phone. The
       report gives shares, not counts, so counts are worked back from them: they match to the player on any window
       where every session has a device, which the recent ones do, and are dropped on long windows where that is not
       true. A side with fewer than ten players is marked, because 1 of 1 is 100% and means nothing. */
    function deviceChart(id,k,noteId){
      var box=el(id),note=el(noteId);
      if(!box)return;
      killChart(id);
      var starts=k.starts||0,mob=k.mobile_start_pct;
      if(!starts||mob==null){
        box.innerHTML='<div class="fh-cvempty">No device data in this window yet.</div>';
        if(note)note.textContent="";
        return;
      }
      var small=starts<=200,mobN=Math.round(starts*mob/100),deskN=Math.max(0,starts-mobN),deskPct=Math.round((100-mob)*10)/10;
      function row(name,color,share,count,fin){
        var line;
        if(small&&count===0)line="No players";
        else if(small){
          line=n(count)+(count===1?" player":" players")+" · "+(fin!=null?n(Math.round(count*fin/100))+" finished ("+Math.round(fin)+"%)":"no finish rate yet");
          if(count<10)line+='<span class="dw">Too few players to compare.</span>';
        }else line=fin!=null?Math.round(fin)+"% of them finished":"No finish rate yet";
        return '<div class="fh-devrow"><div class="dn">'+name+'</div><div class="dbar"><i style="width:'+(share>0?Math.max(2,Math.min(100,share)):0)+'%;background:'+color+'"></i></div><div class="dp">'+Math.round(share)+'%</div><div class="dd">'+line+'</div></div>';
      }
      box.innerHTML='<p class="dh"><b>'+Math.round(mob)+'%</b> of players are on a phone.</p>'+
        row("Phones","#c9a961",mob,mobN,k.mobile_completion_pct)+
        row("Computers","#7c6fae",deskPct,deskN,k.desktop_completion_pct);
      if(note)note.textContent="Finished means they got all the way through the quest, email step included.";
    }
    /* THE THREE NUMBERS THAT MATTER (Jan, Sept 29 2026: "how many emails did I get and how many phone numbers did I get").
       Started, emails collected, phone numbers. The old tiles said "Claimed" and "Email gate", which meant nothing, and
       "Claimed" came from play tracking while the chart beside it counted emails, so the two disagreed. Emails and phone
       numbers now come from the lead list (k.leads, k.phones), the same source as the chart. Each tile carries a small
       bar sized against how many started, so the three read as a funnel. Quest 2 reports no leads yet: its emails fall
       back to the sessions it counted as finished. */
    function questWhen(qd,qh){
      if(qh>0)return qh===1?"In the last hour, ":"In the last "+qh+" hours, ";
      if(qd>=99999)return "So far, ";
      return qd===1?"Today, ":"In the last "+qd+" days, ";
    }
    function questSays(k,qd,qh){
      var s=k.starts||0,e=(k.leads!=null?k.leads:(k.finished||0)),p=k.phones||0,out=questWhen(qd,qh);
      if(!s&&!e)return out+"nobody has started this quest.";
      out+=s?'<b class="s">'+n(s)+(s===1?" person":" people")+'</b> started the quest. ':"nobody started the quest. ";
      if(!e)return out+"No emails came in.";
      out+='<b class="e">'+n(e)+(e===1?" email":" emails")+'</b> came in';
      if(!p)return out+", and none of them came with a phone number.";
      if(p===e)return out+(e===1?", and it came with a phone number.":", and all of them came with a phone number.");
      return out+', and <b class="p">'+n(p)+' of them</b> came with a phone number.';
    }
    function questChip(cls,short,label,tag,value,sub,share){
      return '<div class="fh-chip qc '+cls+'" data-short="'+short+'"><div class="ck">'+label+' · '+tag+'</div><div class="cv">'+value+'</div><div class="cd">'+(sub||"")+'</div><span class="mb" aria-hidden="true"><i style="width:'+share+'%"></i></span></div>';
    }
    function renderQuest(prefix,k,qd,qh){
      k=k||{};
      var prev=k.prev||{}, tag=rngTag(qd,qh);
      var starts=k.starts||0,emails=(k.leads!=null?k.leads:(k.finished||0)),phones=k.phones||0;
      var pEmails=(prev.leads!=null?prev.leads:prev.finished);
      var share=function(v){return starts>0?Math.min(100,Math.round(100*v/starts)):(v>0?100:0)};
      var join=function(a,b){return a&&b?a+" · "+b:(a||b||"")};
      /* nothing then and nothing now says nothing, rather than "flat" under every zero */
      var change=function(now,then){return (!now&&!then)?"":delta(now,then)};
      var eRate=(starts>0&&emails>0&&emails<=starts)?Math.round(100*emails/starts)+"% of starters":"";
      var pRate=emails>0?(phones?Math.round(100*phones/emails)+"% of the emails had one":"none of the emails had one"):"";
      el(prefix+"-chips").innerHTML=
        questChip("qc-s","Started","Started the quest",tag,n(starts),change(starts,prev.starts),starts>0?100:0)+
        questChip("qc-e","Emails","Emails collected",tag,n(emails),join(eRate,change(emails,pEmails)),share(emails))+
        questChip("qc-p","Phone numbers","Phone numbers",tag,n(phones),join(pRate,change(phones,prev.phones)),share(phones));
      var says=el(prefix+"-says");
      if(says){says.innerHTML=questSays(k,qd,qh);says.hidden=false}
    }

    return {renderQuest:renderQuest,renderSplit:renderSplit,deviceChart:deviceChart,series:questSeries};
  };
  /* the section may already be waiting for this file */
  try{window.dispatchEvent(new Event("ff-quest-view-ready"))}catch(e){}
})();
